import React from 'react';
import moment from 'moment';
import { shortDateFormat } from './dateUtils';

export const getOrderInformationConfirmation = data => ({
    title: 'Order Information',
    content: [
        [
            { label: 'Reference Number', value: data.referenceNumber },
        ],
    ],
});

export const getContactInformationConfirmation = data => ({
    title: 'Contact Information',
    content: [
        [
            { label: 'Contact', value: data.contactInformation.contactName },
            { label: 'Email Confirmation to', value: data.contactInformation.confirmationEmail },
        ],
    ],
});

export const getDeliveryInformationConfirmation = data => ({
    title: 'Delivery Information',
    content: [
        [
            { label: 'Email Results', value: data.deliveryPreference.email },
            { label: 'Additional Email', value: data.deliveryPreference.additionalEmail },
            {
                label: 'Rush Order',
                value: data.deliveryPreference.rushDate
                    ? moment(data.deliveryPreference.rushDate).format(shortDateFormat)
                    : null,
            },
        ],
    ],
});

export const getChanceryDeliveryInformationConfirmation = data => ({
    title: 'Delivery Information',
    content: [
        [
            { label: 'Email Results', value: data.deliveryPreference.email },
            { label: 'Additional Email', value: data.deliveryPreference.additionalEmail },
            {
                label: 'Due Date',
                value: data.deliveryPreference.rushDate
                    ? moment(data.deliveryPreference.rushDate).format(shortDateFormat)
                    : null,
            },
        ],
    ],
});

export const parseTextWithPrices = text => {
    const pricePattern = /\$ ?\d{1,3}(?:,\d{3})*(?:\.\d{2})?/g;
    const matches = Array.from(text.matchAll(pricePattern));

    if (matches.length === 0) return [text];

    return matches.reduce(
        (acc, match, i) => {
            const prevEnd = acc.lastEnd;
            const start = match.index;
            const end = start + match[0].length;

            const before = text.slice(prevEnd, start);
            if (before) acc.parts.push(before);

            acc.parts.push(<span className="text-nowrap" key={end}>{match[0]}</span>);
            acc.lastEnd = end;

            if (i === matches.length - 1 && end < text.length) {
                acc.parts.push(text.slice(end));
            }

            return acc;
        },
        { parts: [], lastEnd: 0 },
    ).parts;
};

export const getMainInformationConfirmation = ({ reportInfoList }, columns = ['type', 'reportName', 'price']) => {
    const availableColumns = {
        type: {
            title: 'Report',
            dataIndex: 'type',
        },
        reportName: {
            title: 'Name(s)',
            dataIndex: 'reportName',
        },
        price: {
            title: 'Price',
            dataIndex: 'price',
            render: parseTextWithPrices,
        },
    };
    return ({
        columns: columns.map(column => availableColumns[column]),
        data: reportInfoList,
    });
};

export const showErrorsIfInvalidOrPerformAction = (form, action) => {
    const { valid } = form.getState();
    if (!valid) {
        form.submit(); //to focus and scroll to error
    } else {
        action();
    }
};

export const gutter = 32;
